<template>
    <div class="form">
        <ValidationObserver ref="form">
            <div class="row">

                <ValidationProvider
                    class="col-12"
                    name="Company Name"
                    v-slot="{ errors }"
                    rules="required"
                >
                    <label class="form-group">
                        <span class="form-label">Company Name</span>
                        <select
                            class="custom-select pl-4"
                            v-model="form.company"
                        >
                            <option
                                v-for="company in companies"
                                :key="company.id"
                                :value="company.id">
                                {{company.name}}
                            </option>
                        </select>
                        <FormError :error="errors[0]"  name="Company Name"></FormError>
                    </label>
                </ValidationProvider>

                <ValidationProvider
                    class="col-12"
                    name="Position"
                    v-slot="{ errors }"
                    rules="required|min:3"
                >
                    <label class="form-group">
                        <span class="form-label">Position/Title</span>
                        <input
                            type="text"
                            v-model="form.position"
                            class="form-control"
                        >
                        <FormError :error="errors[0]"  name="Position"></FormError>
                    </label>
                </ValidationProvider>

                <ValidationProvider
                    class="col-sm-6"
                    name="First Name"
                    v-slot="{ errors }"
                    rules="required|min:3|alpha"
                >
                    <label class="form-group">
                        <span class="form-label">First Name*</span>
                        <input
                            type="text"
                            v-model="form.first_name"
                            class="form-control"
                        >
                        <FormError :error="errors[0]"  name="First Name"></FormError>
                    </label>

                </ValidationProvider>

                <ValidationProvider
                    class="col-sm-6"
                    name="Last Name"
                    v-slot="{ errors }"
                    rules="required|min:3|alpha"
                >
                    <label class="form-group">
                        <span class="form-label">Last Name*</span>
                        <input type="text" v-model="form.last_name" class="form-control">
                        <FormError :error="errors[0]"  name="Last Name"></FormError>
                    </label>
                </ValidationProvider>

                <ValidationProvider
                    class="col-sm-6"
                    name="Email"
                    v-slot="{ errors }"
                    rules="required|email"
                >
                    <label class="form-group">
                        <span class="form-label">Email Address*</span>
                        <input
                            type="email"
                            v-model="form.email"
                            class="form-control"
                        >
                        <FormError :error="errors[0]"  name="Email"></FormError>
                    </label>

                </ValidationProvider>

                <ValidationProvider
                    class="col-sm-6"
                    name="Phone"
                    v-slot="{ errors }"
                    rules="required"
                >
                    <label class="form-group">
                        <span class="form-label">Phone Number*</span>
                        <input
                            type="text"
                            class="form-control"
                            v-mask="'+1 (###) ###-####'"
                            v-model="form.phone"
                        >
                        <FormError :error="errors[0]"  name="Phone"></FormError>
                    </label>

                </ValidationProvider>

                <ValidationProvider
                    class="col-sm-6"
                    name="password"
                    v-slot="{ errors }"
                    rules="min:8|max:20|password_strength|required"
                >
                    <label class="form-group">
                        <span class="form-label">Password*</span>
                        <input
                            type="text"
                            v-model="form.password"
                            class="form-control"
                            placeholder="Enter your password"
                        >
                        <FormError :error="errors[0]" style="color: red; font-size: 10px"  name="password"></FormError>
                    </label>

                </ValidationProvider>

                <ValidationProvider
                    class="col-sm-6"
                    name="Password"
                    rules="confirmed:password"
                    v-slot="{ errors }"
                >
                    <label class="form-group">
                        <span class="form-label">Confirm Password*</span>
                        <input
                            type="password"
                            v-model="form.password_confirmation"
                            class="form-control"
                            data-vv-as="password"
                        >
                        <FormError :error="errors[0]" style="color: red; font-size: 10px" name="Password"></FormError>
                    </label>
                </ValidationProvider>

                <ValidationProvider
                    class="col-12"
                    name="Terms and Conditions"
                    v-slot="{ errors }"
                    rules="required"
                >
                    <div class="form-group mb-5 mt-2">
                        <label class="form-check">
                            <input type="checkbox" v-model="form.agree" class="form-check-input-checkbox">
                            <span class="form-check-label">Accept
                                <a
                                    href="javascript:void(0)"
                                    @click="showCustomModal('terms', 1)"
                                >
                                    Terms and Conditions
                                </a> and
                                <a href="">Privacy Policy</a>
                            </span>
                            <FormError :error="errors[0]"  name="Terms and Conditions"></FormError>
                        </label>
                    </div>
                </ValidationProvider>

                <TermsAndConditions
                    :modal-id="getCustomModalId('terms', 1)"
                />

                <div class="col-12">
                    <div class="form-group">
                        <button
                            type="submit"
                            class="btn btn_golden w-100"
                            @click="validateForm"
                        >
                            <span>register</span>
                        </button>
                    </div>
                </div>
            </div>
        </ValidationObserver>
    </div>
</template>

<script>
import FormError from "../Common/FormError.vue";
import RegisterAndLoginServices from "../../services/RegisterAndLoginServices";
import ModalHandler from "../../mixins/ModalHandler";
import TermsAndConditions from "../Common/TermsAndConditions.vue";
import CommonServices from "../../services/CommonServices";

export default {
    name: "ClientRegister",
    components: {TermsAndConditions, FormError},
    mixins: [ModalHandler],
    data() {
        return {
            passwordError: null,
            companies: [],
            form: {
                type: 'client',
                company: null,
                position: null,
                first_name: null,
                last_name: null,
                email: null,
                phone: null,
                agree: null,
                password: null,
                password_confirmation: null,
                code: null,
            }
        }
    },
    methods: {
        async validateForm() {
            this.$showLoadingMessage()
            const valid = await this.$refs.form.validate();

            if (!valid) {
                this.$showValidationErrorMessage();
                return;
            }
            await this.register()
        },
        async register() {
            try {
                await RegisterAndLoginServices.clientRegister(this.form)
                this.$showSuccessMessage()
                window.location.href = '/login'
            } catch (e) {
                this.$showErrorMessage('The user was not registered')
            }
        },
        async fetchCompanies() {
            try {
                const { data: response } = await CommonServices.getCompanies()
                this.companies = response
            } catch (e){

            }
        }
    },
    mounted() {
        this.fetchCompanies()
        const urlParams = new URLSearchParams(window.location.search);
        this.form.code = urlParams.get('code')
    }

}

</script>



<style scoped>

</style>
